import { ColumnToIndex, IndexToColumn } from '../../common/domain/mappings';

export const translateToColumnMapping = (
  mapping: IndexToColumn,
): ColumnToIndex => {
  var result = {};
  var keys = Object.keys(mapping);
  for (var i = 0; i < keys.length; i++) {
    result[mapping[keys[i]]] = parseInt(keys[i]);
  }
  return result;
};

export const translateToIndexMapping = (
  mapping: ColumnToIndex,
): IndexToColumn => {
  var result = {};
  var keys = Object.keys(mapping);
  for (var i = 0; i < keys.length; i++) {
    result[mapping[keys[i]]] = keys[i];
  }
  return result;
};
